import root from 'window-or-global';

export const scrollTo = (x, y) => root.scrollTo(x, y);
